import React from 'react';

interface SupportButtonTypeExternalLinkProps {
    element: any
}

const SupportButtonTypeExternalLink: React.FC<SupportButtonTypeExternalLinkProps> = (element) => {

    const handleLinks = (links: any) => {
        if(links){
            return Array.isArray(links) && links.map((item, index) => (
                <a href={item?.ButtonLink} target={item?.OpenLinkInANewTab ? "_blank" : ""} className={index == 0 ? "d-block mx-auto bordered-btn button-type-links font-medium" : "d-block mt-4 mx-auto bordered-btn button-type-links font-medium"} key={index}>{item?.ButtonLinkText}</a>
            ))
        }
    }

    return (
      <>
        <div className="container-fluid spacer-top">{handleLinks(element?.element?.ExternalLink)}</div>
      </>
    );
};

export default SupportButtonTypeExternalLink;